import _ from 'lodash';

/**
 * Implement shuffle when items are randomized, if that's not implement sortBy.
 * @param {array} array The original array.
 * @param {string} field The field used to order.
 * @param {boolean} randomize If the array should be shuffled.
 * @returns A new array ordered or shuffled.
 */
export const orderArray = (array, field, randomize) => {
  if (randomize) {
    return _.shuffle(array);
  }

  return _.sortBy(array, field);
};
